import React from "react";

import {
    getDataFromResponse,
    getDataWithPromise,
    getNumRowsFromResponse,
    Globals,
} from  '../DataFunctions/BaseDataFns';

export const groupStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: 'green',
    fontStyle: 'bold',
    fontSize: 'large'
};

export const groupBadgeStyles = {
    backgroundColor: '#EBECF0',
    borderRadius: '2em',
    display: 'inline-block',
    fontWeight: 'normal',
    lineHeight: '1',
    minWidth: 1,
    padding: '0.16666666666667em 0.5em',
    textAlign: 'center',
    color: 'green',
    fontStyle: 'bold',
    fontSize: 'large'
};

export const formatGroupLabel = data => (
    <div style={groupStyles}>
        <span>{data.label}</span>
        <span style={groupBadgeStyles}>{data.options.length}</span>
    </div>
);

export const getEducationStatusData = ( showAcademicYear, halfTermsOnly ) =>
{
    const ungroupedItems = ( data ) =>
    {
        const groups = data.map ( (elem) => { return { value: +(elem.education_status_id), label: elem.es_description}});

        return ( groups );
    }

    const url = Globals.APIFolder + '/educationstatus' ;

    return new Promise((resolve, reject) =>
    {
        if (url == null || url === '')
        {
            throw Error('getDataWithPromise cannot call an empty URL');
        }
        else
        {
            getDataWithPromise(url, 'GET', {}).then(response =>
            {
                const rows = getNumRowsFromResponse(response) > 0 ? getDataFromResponse(response) : [];

                resolve ( ungroupedItems(rows)) ;
            })
               .catch((jqXHR, textStatus, error) =>
               {
                   reject(jqXHR, textStatus, error);
               });
        }
    });
}

export const getSchoolTermData = ( showAcademicYear, halfTermsOnly ) =>
{
    const ungroupedTerms = ( data ) =>
    {
        const groups = data.map ( (elem) => { return { value: elem.year_term_id, label: elem.friendly_name}});

        if ( showAcademicYear === true )
        {
            groups.push ({ value: 999, label: 'This Academic Year'})
            groups.push ({ value: 998, label: 'Last Academic Year'})
        }

        return ( groups );
    }

    const filter = halfTermsOnly === true ? '?filter=half-terms' : ''

    const url = Globals.APIFolder + '/terms' + filter;

    return new Promise((resolve, reject) =>
    {
        if (url == null || url === '')
        {
            throw Error('getDataWithPromise cannot call an empty URL');
        }
        else
        {
            getDataWithPromise(url, 'GET', {}).then(response =>
            {
                const rows = getNumRowsFromResponse(response) > 0 ? getDataFromResponse(response) : [];

                resolve ( ungroupedTerms(rows)) ;
            })
                .catch((jqXHR, textStatus, error) =>
                {
                    reject(jqXHR, textStatus, error);
                });
        }
    });
}

export const getAllAcademicYears = () =>
{
    const url = Globals.APIFolder + '/years/unique';

    return new Promise((resolve, reject) =>
    {
        if (url == null || url === '')
        {
            throw Error('getAllAcademicYears cannot call an empty URL');
        }
        else
        {
            getDataWithPromise(url, 'GET', {}).then(response =>
            {
                resolve ( getNumRowsFromResponse(response) > 0 ? getDataFromResponse(response) : [] );
            })
                .catch((jqXHR, textStatus, error) =>
                {
                    reject(jqXHR, textStatus, error);
                });
        }
    });
}

export const getTransitions = () =>
{
    const ungroupedItems = ( data ) =>
    {
        const groups = data.map ( (elem) => { return { value: +(elem.transition_id), label: elem.transition_description}});

        return ( groups );
    }

    const url = Globals.APIFolder + '/transitions';

    return new Promise((resolve, reject) =>
    {
        if (url == null || url === '')
        {
            throw Error('getTransitions cannot call an empty URL');
        }
        else
        {
            getDataWithPromise(url, 'GET', {}).then(response =>
            {
                resolve ( getNumRowsFromResponse(response) > 0 ? ungroupedItems(getDataFromResponse(response)) : [] );
            })
                .catch((jqXHR, textStatus, error) =>
                {
                    reject(jqXHR, textStatus, error);
                });
        }
    });
}

export const getSchoolsWithPupils = ( ) =>
{
    const ungroupedTerms = ( data ) =>
    {
        const groups = data.map ( (elem) => { return { value: elem.school_id, label: elem.school_name}});

        return ( groups );
    }

    const url = Globals.APIFolder + '/schools?registration' ;

    return new Promise((resolve, reject) =>
    {
        if (url == null || url == '')
        {
            throw Error('getDataWithPromise cannot call an empty URL');
        }
        else
        {
            getDataWithPromise(url, 'GET', {}).then(response =>
            {
                const rows = getNumRowsFromResponse(response) > 0 ? getDataFromResponse(response) : [];

                resolve ( ungroupedTerms(rows)) ;
            })
                .catch((jqXHR, textStatus, error) =>
                {
                    reject(jqXHR, textStatus, error);
                });
        }
    });
}

export const getCountries = ( ) =>
{
    const ungroupedTerms = ( data ) =>
    {
        const groups = data.map ( (elem) => { return { value: +(elem.country_id), label: elem.nicename}});

        return ( groups );
    }

    const url = Globals.APIFolder + '/countries' ;

    return new Promise((resolve, reject) =>
    {
        if (url === null || url === '' || url === undefined )
        {
            throw Error('getDataWithPromise cannot call an empty URL');
        }
        else
        {
            getDataWithPromise(url, 'GET', {}).then(response =>
            {
                const rows = getNumRowsFromResponse(response) > 0 ? getDataFromResponse(response) : [];

                resolve ( ungroupedTerms(rows)) ;
            })
               .catch((jqXHR, textStatus, error) =>
               {
                   reject(jqXHR, textStatus, error);
               });
        }
    });
}

export const getSchoolAttendanceOfficers = ( school_id ) =>
{
    const ungroupedOfficers = ( data ) =>
    {
        const groups = data.map ( (elem) => { return { value: elem.user_id, label: elem.name}});

        return ( groups );
    }

    const url = Globals.APIFolder + '/schools/' + school_id + '/attendanceofficers' ;

    return new Promise((resolve, reject) =>
    {
        if (url == null || url == '')
        {
            throw Error('getDataWithPromise cannot call an empty URL');
        }
        else
        {
            getDataWithPromise(url, 'GET', {}).then(response =>
            {
                const rows = getNumRowsFromResponse(response) > 0 ? getDataFromResponse(response) : [];

                resolve ( ungroupedOfficers(rows)) ;
            })
                .catch((jqXHR, textStatus, error) =>
                {
                    reject(jqXHR, textStatus, error);
                });
        }
    });
}

export const getCustomerHouses = ( customer_id ) =>
{
    const url = Globals.APIFolder + '/customers/' + customer_id + '/teams?list' ;

    return new Promise((resolve, reject) =>
    {
        if (url == null || url == '')
        {
            throw Error('getDataWithPromise cannot call an empty URL');
        }
        else
        {
            getDataWithPromise(url, 'GET', {}).then(response =>
            {
                const rows = getNumRowsFromResponse(response) > 0 ? getDataFromResponse(response) : [];

                resolve ( rows ) ;
            })
                .catch((jqXHR, textStatus, error) =>
                {
                    reject(jqXHR, textStatus, error);
                });
        }
    });
}

export const getSchoolYearData = ( includeEarly, includeAll ) =>
{
    let years = [] ;

    if ( includeEarly === true )
    {
        years = [
            { value: 14, label: 'Nursery'},
            { value: 15, label: 'Reception'},
            { value: 17, label: 'Early Years'},
            { value: 1, label: 'Year 1'},
            { value: 2, label: 'Year 2'},
            { value: 3, label: 'Year 3'},
            { value: 4, label: 'Year 4'},
            { value: 5, label: 'Year 5'},
            { value: 6, label: 'Year 6'},
            { value: 7, label: 'Year 7'},
            { value: 8, label: 'Year 8'},
            { value: 9, label: 'Year 9'},
            { value: 10, label: 'Year 10'},
            { value: 11, label: 'Year 11'},
            { value: 12, label: 'Year 12'},
            { value: 13, label: 'Year 13'}];
    }
    else
    {
        years = [
            { value: 1, label: 'Year 1'},
            { value: 2, label: 'Year 2'},
            { value: 3, label: 'Year 3'},
            { value: 4, label: 'Year 4'},
            { value: 5, label: 'Year 5'},
            { value: 6, label: 'Year 6'},
            { value: 7, label: 'Year 7'},
            { value: 8, label: 'Year 8'},
            { value: 9, label: 'Year 9'},
            { value: 10, label: 'Year 10'},
            { value: 11, label: 'Year 11'},
            { value: 12, label: 'Year 12'},
            { value: 13, label: 'Year 13'}];
    }

    if ( includeAll )
    {
        years.push ( {value: 999, label: 'All'}) ;
    }

    return new Promise((resolve, reject) =>
    {
        resolve(years);
    });
}

export const getNonPaymentReasons = () =>
{
    const reasons = [
        { value: 1, label: 'CfC Date'},
        { value: 2, label: 'Independent School'},
        { value: 3, label: 'Age'}
    ];

    return new Promise((resolve, reject) =>
    {
        resolve(reasons);
    });
}

export const getAdulthoodYearGroups = ( isPost16 ) =>
{
    const post16 = isPost16 ? [{
        value: 10,
        label: 'Age 16+'
    }] : [] ;

    const reasons = [
        {
            value: 5,
            label: 'Up to Year 6'
        },
        {
            value: 6,
            label: 'Year 7+'
        },
       ...post16
    ];

    return new Promise((resolve, reject) =>
    {
        resolve(reasons);
    });
}

export const getAlternateProvisionReasons = () =>
{
    const reasonDropdownContent = ( data ) =>
    {
        const groups = data.map ( (elem) => { return { value: elem.ap_reason_id, label: elem.ap_reason_text}});

        return ( groups );
    }

    const url = Globals.APIFolder + '/apreasons' ;

    return new Promise((resolve, reject) =>
    {
        if (url == null || url == '')
        {
            throw Error('getDataWithPromise cannot call an empty URL');
        }
        else
        {
            getDataWithPromise(url, 'GET', {}).then(response =>
            {
                const rows = getNumRowsFromResponse(response) > 0 ? getDataFromResponse(response) : [];

                resolve ( reasonDropdownContent(rows)) ;
            })
               .catch((jqXHR, textStatus, error) =>
               {
                   reject(jqXHR, textStatus, error);
               });
        }
    });
}

export const getSchoolMoveReasons = () =>
{
    const reasonDropdownContent = ( data ) =>
    {
        const groups = data.map ( (elem) => { return { value: elem.leaving_reason_id, label: elem.leaving_reason_text}});

        return ( groups );
    }

    const url = Globals.APIFolder + '/schoolmovereasons' ;

    return new Promise((resolve, reject) =>
    {
        if (url == null || url === '')
        {
            throw Error('getDataWithPromise cannot call an empty URL');
        }
        else
        {
            getDataWithPromise(url, 'GET', {}).then(response =>
            {
                const rows = getNumRowsFromResponse(response) > 0 ? getDataFromResponse(response) : [];

                resolve ( reasonDropdownContent(rows)) ;
            })
               .catch((jqXHR, textStatus, error) =>
               {
                   reject(jqXHR, textStatus, error);
               });
        }
    });
}

export const getExLacChildren = () =>
{
    const reasonDropdownContent = ( data ) =>
    {
        const groups = data.map ( (elem) => { return { value: elem.child_id, label: elem.firstname + " " + elem.surname}});

        return ( groups );
    }

    const url = Globals.APIFolder + '/children/exlac' ;

    return new Promise((resolve, reject) =>
    {
        if (url == null || url == '')
        {
            throw Error('getDataWithPromise cannot call an empty URL');
        }
        else
        {
            getDataWithPromise(url, 'GET', {}).then(response =>
            {
                const rows = getNumRowsFromResponse(response) > 0 ? getDataFromResponse(response) : [];

                resolve ( reasonDropdownContent(rows)) ;
            })
               .catch((jqXHR, textStatus, error) =>
               {
                   reject(jqXHR, textStatus, error);
               });
        }
    });
}